// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7217":"58c90fd1","8598":"274dd791","9124":"274dd791"}[chunkId] + ".chunk.css";
};